import DatePeriodsEnum from '../../../enums/date-periods.enum';

class SaveAssemblyDeliveryPreferencesDto {
  deliveryDatePreference!: string;
  deliveryDatePeriodPreference!: DatePeriodsEnum;
}

export default SaveAssemblyDeliveryPreferencesDto;
